import { listFieldsState, fieldStateFragment } from 'graphql/operations';

const FIELD_STATE_TYPENAME = 'FieldState';
const FIELD_STATE_VARIABLES_TYPENAME = 'FieldStateVariables';

function getFieldState(id, loading, lastUpdated, fieldType, variables, previous = {}) {
  return {
    ...previous,
    __typename: FIELD_STATE_TYPENAME,
    id,
    loading,
    lastUpdated,
    fieldType,
    variables: {
      __typename: FIELD_STATE_VARIABLES_TYPENAME,
      ...variables
    }
  };
}

// Clearing cache on logout does not reset the store properly.
// Using try/catch to reset the store.
function getCachedFieldsState(cache) {
  let data;
  try {
    data = cache.readQuery({ query: listFieldsState });
  } catch {
    data = { listFieldsState: [] };
    cache.writeQuery({ query: listFieldsState, data });
  }
  return data;
}

const fieldStateConfig = {
  resolvers: {
    Query: {
      getFieldStateById(_, args, { cache }) {
        const { id } = args;
        const result = getCachedFieldsState(cache);
        return result.listFieldsState.find(field => field.id === id) || [];
      }
    },
    Mutation: {
      setFieldState: (_, { id, loading, lastUpdated, fieldType, variables }, { cache, getCacheKey }) => {
        const cacheKey = getCacheKey({ __typename: FIELD_STATE_TYPENAME, id });
        let fieldState = cache.readFragment({ fragment: fieldStateFragment, id: cacheKey });
        if (fieldState) {
          const updatedFieldState = getFieldState(id, loading, lastUpdated, fieldType, variables, fieldState);
          cache.writeData({ data: { [cacheKey]: updatedFieldState } });
        } else {
          const previous = getCachedFieldsState(cache);
          fieldState = getFieldState(id, loading, lastUpdated, fieldType, variables, fieldState);
          const data = { listFieldsState: [...previous.listFieldsState, fieldState] };
          cache.writeQuery({ query: listFieldsState, data });
        }
        return null;
      }
    }
  }
};

export default fieldStateConfig;
